/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { objectiveHealthResponseSchema } from './objectiveHealthResponseSchema';

export const objectiveHealthByIdsResponseSchema = z.object({
  get data() {
    return z.array(objectiveHealthResponseSchema);
  },
});
